export type Bonus = {
  id: string
  value: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    id: 'BONO 01',
    value: 'valor $49',
    title: 'El Detector de Nivel 360',
    description:
      'Ubica a cualquier alumno nuevo en el nivel correcto en menos de 5 minutos. Se acabó adivinar el primer día.',
  },
  {
    id: 'BONO 02',
    value: 'valor $54',
    title: 'Físico Express',
    description:
      'Rutinas físicas de 15 minutos integradas en tus sesiones. Más rendimiento, menos lesiones y cero equipamiento extra.',
  },
  {
    id: 'BONO 03',
    value: 'valor $59',
    title: 'Nutrición y Rendimiento en Cancha',
    description:
      'Qué comer, beber y evitar antes, durante y después de las sesiones. Más energía en tus alumnos y mejores resultados.',
  },
  {
    id: 'BONO 04',
    value: 'valor $64',
    title: 'El Plan para Días de Lluvia',
    description:
      '10 sesiones bajo techo completas y listas para dar. Nunca más canceles una clase por el clima.',
  },
  {
    id: 'BONO 05',
    value: 'valor $49',
    title: 'El Kit de Supervivencia',
    description:
      'Protocolos de emergencia para grupos mixtos, falta de material, comienzos tarde o alumnos difíciles.',
  },
  {
    id: 'BONO 06',
    value: 'valor $43',
    title: 'El Pack de Organización Semanal',
    description:
      'Planillas de asistencia, control de pagos y plantillas de planificación semanal. Gestiona tus clases como un negocio profesional.',
  },
]
